import EntityContentType from './EntityContentType';

const EntityAPIPath = Object.freeze({
  [EntityContentType.ANNOUNCEMENT]: 'announcements',
  [EntityContentType.CAMPAIGN]: 'campaigns',
  [EntityContentType.CAMPAIGN_CREATED]: 'campaigns',
  [EntityContentType.CAMPAIGN_GOAL_MET]: 'campaigns',
  [EntityContentType.CAMPAIGN_STRETCH_GOAL_ADDED]: 'campaigns',
  [EntityContentType.CAMPAIGN_STRETCH_GOAL_MET]: 'campaigns',
  [EntityContentType.DONATION]: 'donations',
  [EntityContentType.EMAIL_RECEIVED]: 'comms',
  [EntityContentType.EMAIL_SENT]: 'comms',
  [EntityContentType.INTERACTION]: 'interactions',
  [EntityContentType.TASK]: 'tasks',
});

export default EntityAPIPath;
